// extracted by mini-css-extract-plugin
export var buttonAccess = "gated-modal-form-module--buttonAccess--L1wwV";
export var checkboxAccess = "gated-modal-form-module--checkboxAccess--buebB";
export var gatedModalFormBox = "gated-modal-form-module--gatedModalFormBox--g0T+l";
export var gatedModalFormWrapper = "gated-modal-form-module--gatedModalFormWrapper--nuBRs";